import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { bound } from 'Helpers/Utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  progressSection: {
    display: 'flex',
    alignItems: 'center',
  },
  progressBar: {
    background: theme.palette.facet.accentGreen4,
    height: '5px',
    marginRight: theme.spacing(1),
  },
  progressPercent: {
    color: theme.palette.facet.accentGreen4,
    ...theme.typography.h6,
  },
  progressBarComplete: {
    backgroundColor: theme.palette.facet.accentBlue8,
  },
  completedColor: {
    color: theme.palette.facet.accentBlue8,
  },
  label: {
    color: theme.palette.facet.accentGreen4,
    paddingRight: '1rem',
  },
}));

const GrowingProgressBar = ({ label, progress, completed }) => {
  const classes = useStyles();

  const width = `${bound(1, 100)(progress)}%`;

  return (
    <div className={classes.progressSection}>
      {label && <div className={classes.label}>{label}</div>}
      <div
        style={{ width }}
        className={classNames(classes.progressBar, {
          [classes.progressBarComplete]: completed,
        })}
      />
      <span
        className={classNames(classes.progressPercent, {
          [classes.completedColor]: completed,
        })}
      >
        {`${progress}%`}
      </span>
    </div>
  );
};

GrowingProgressBar.propTypes = {
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  completed: PropTypes.bool,
  label: PropTypes.string,
};

GrowingProgressBar.defaultProps = {
  completed: false,
  label: '',
};

export default GrowingProgressBar;
